import NotFoundPage from "./NotFoundPage";
import ValidationProcess from "./ValidationProcess";
import ValidationProcessCompleted from "./ValidationProcessCompleted";

export {
  NotFoundPage,
  ValidationProcess,
  ValidationProcessCompleted
};
